module.exports = __webpack_public_path__ + "img/md.215154af.svg";